"use strict";
// Path/filename constraints and upload-ticket policy values. Shared between
// server-side rejection rules and client-side pre-flight filtering.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOWNLOAD_URL_EXPIRY_SECONDS = exports.UPLOAD_TICKET_CONSTRAINTS = exports.S3_PATH_CONSTRAINTS = void 0;
exports.S3_PATH_CONSTRAINTS = {
    // File paths must be within these prefixes
    ALLOWED_PREFIXES: ['originals/', 'derivatives/'],
    // Maximum path length
    MAX_PATH_LENGTH: 1024,
    // Filename character policy. The original filename is *metadata only* — the
    // S3 object key is UUID-based (`originals/<fileId>`), never the name — so
    // there is no path-safety reason to restrict it to an allow-list. We accept
    // any name a real operating system produces (accents, apostrophes, commas,
    // "@", "#", brackets, en-dashes, currency signs, CJK, …) and reject only
    // what is genuinely unsafe to store or echo back in a download header:
    // Unicode control characters (`\p{Cc}` — C0, C1 and DEL) and the path
    // separators "/" and "\". Requires the `u` flag — both for `\p{Cc}` itself
    // and for consumers that rebuild this from `.source` (see file-upload-api).
    FILENAME_PATTERN: /^[^\p{Cc}/\\]+$/u,
    // Maximum filename length
    MAX_FILENAME_LENGTH: 255,
};
exports.UPLOAD_TICKET_CONSTRAINTS = {
    // Short-lived presigned URLs (1–3 minutes)
    PRESIGNED_URL_EXPIRY_SECONDS: 180,
    // JWT token expiry. The token is checked when the browser reports the upload
    // done, i.e. AFTER the bytes went up, so it must outlive the slowest upload
    // we accept (a 300MB PLU on a slow connection), not just the presigned URL —
    // S3 only checks the URL's signature when the PUT starts.
    JWT_EXPIRY_SECONDS: 3600,
    // Maximum number of pending uploads per user
    MAX_PENDING_UPLOADS_PER_USER: 10,
    // Maximum number of uploads per project per hour
    MAX_UPLOADS_PER_PROJECT_PER_HOUR: 50,
};
exports.DOWNLOAD_URL_EXPIRY_SECONDS = 21600; // 6 hours
//# sourceMappingURL=s3.js.map